import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { ReservationsInBatch as ServerReservationsInBatch } from 'data/models/ReservationsInBatch';
import { ReservationsInBatch } from './model';
import { ReservationsListBaseView, ActionsMenuFactoryParams } from 'portcall/reservationslistbase/view';
import { PCModal } from 'portcall/pcmodal/view';
import { ActionLoadingIndicator } from 'core/actionloadingindicator/view';

export const ReservationsInBatchView = SuperCritical(({ model: m } : { model : ReservationsInBatch }) => {
    return (
        <div className="reservations-in-batch">
            <ReservationsListBaseView<ServerReservationsInBatch>
                model={m}
                title={() => m.Batch() ? 'Batch #' + m.Batch()!.ReferenceNumber() : ''}
                actionsMenuFactory={actionsMenuFactory}
                csvExportFileName={() => 'batch' + (m.Batch() ? '_' + m.Batch()!.ReferenceNumber() : '') + '.csv'} />
            <ConfirmDeleteBatchModal model={m} />
        </div>
    );

    function actionsMenuFactory({
        printMenuItem,
        csvExportMenuItem,
        cancelReservationsMenuItem,
        bookReservationsMenuItem,
        adminSeparator
    } : ActionsMenuFactoryParams) {
        return (
            <div>
                {printMenuItem}
                {csvExportMenuItem}
                {cancelReservationsMenuItem}
                {(m.AnyBookableRows() || m.Model().CanDelete()) && adminSeparator}
                {bookReservationsMenuItem}
                {m.Batch() && m.Model().CanDelete() && <DeleteBatchMenuItem model={m} />}
            </div>
        );
    }
});

let DeleteBatchMenuItem = SuperCritical(({ model: m } : { model : ReservationsInBatch }) =>
    <div className="action-item">
        <div>
            <a href="" onClick={noDefault(m.ConfirmDeleteBatch)}>Delete Batch</a>
        </div>
        <div className="pc-text-smalllabel pc-action-item-descr">
            Delete all PortCalls in this batch. Caution.
        </div>
    </div>
);

let ConfirmDeleteBatchModal = SuperCritical(({ model: m } : { model : ReservationsInBatch }) =>
    <PCModal className="confirm-delete-batch-modal" shown={m.ShowConfirmDeleteBatch} onBackDropClick={() => m?.ShowConfirmDeleteBatch(false)}>
        <div className="modal-content">
            <div className="modal-body">
                <h3 className="title">Delete Batch</h3>
                <div>Are you sure you want to delete all the PortCalls and reservations in this batch?</div>
                <div className="actions">
                    {/* TH 12/22/2016 -- Prevent cancel while delete in progress */}
                    <a href="" className="cancel" onClick={noDefault(() => !m.DeletingBatch() && m.ShowConfirmDeleteBatch(false))}>Cancel</a>
                    <button className="pc-button pc-button-primary"
                        disabled={m.DeletingBatch()}
                        onClick={m.DeleteBatch}>Delete</button>
                </div>
                <ActionLoadingIndicator loading={m.DeletingBatch} />
            </div>
        </div>
    </PCModal>
);


// WEBPACK FOOTER //
// ./apps/portcall/reservationsinbatch/view.tsx